<template>
  <div>
    <div class="error-box" ref="ErrorContainer">
      <slot name="default" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorContainer"
};
</script>

<style lang="scss" scoped>
@import "../../utils/assets/stylesheets/variables.scss";

.error-box {
  padding: 30px;
  background-color: $error-lighten-1;

  border-radius: $border-radius;
  overflow: hidden;
  position: relative;

  h6 {
    color: $error;
    font-weight: 600;
    z-index: 1 !important;
    position: relative;
  }

  p,
  li {
    color: $error;
    z-index: 1 !important;
    position: relative;
  }
}

.multiple-message-spacer {
  display: block;
  height: 20px;
}
</style>
